exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.in[data-v-b98d9d5a] {\n    display: block;\n}\n.products-table[data-v-b98d9d5a] {\n    font-size: 13px;\n}\n", ""]);

// exports
